var React = require('react');

function LogoutIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.452 14.823c-.523.173-.812.74-.588 1.244a10 10 0 1 0 .021-8.18c-.227.503.06 1.071.582 1.247.522.175 1.082-.11 1.322-.607a8.004 8.004 0 1 1-.018 6.91c-.236-.499-.795-.787-1.319-.614z","fill":"#fff","key":0}),React.createElement("path",{"d":"M12.707 7.293a1 1 0 1 0-1.414 1.414L13.586 11H2a1 1 0 1 0 0 2h11.586l-2.293 2.293a1 1 0 0 0 1.414 1.414L17.414 12l-4.707-4.707z","fill":"#fff","key":1})]);
}

LogoutIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LogoutIcon;

LogoutIcon.default = LogoutIcon;
